__turbopack_context__.v({
  "tooltip": "CustomTooltip-module-scss-module__-Bf8oq__tooltip",
  "tooltip--auto": "CustomTooltip-module-scss-module__-Bf8oq__tooltip--auto",
  "tooltip--bottom": "CustomTooltip-module-scss-module__-Bf8oq__tooltip--bottom",
  "tooltip--left": "CustomTooltip-module-scss-module__-Bf8oq__tooltip--left",
  "tooltip--right": "CustomTooltip-module-scss-module__-Bf8oq__tooltip--right",
  "tooltip--top": "CustomTooltip-module-scss-module__-Bf8oq__tooltip--top",
  "tooltipArrow": "CustomTooltip-module-scss-module__-Bf8oq__tooltipArrow",
  "tooltipArrow--bottom": "CustomTooltip-module-scss-module__-Bf8oq__tooltipArrow--bottom",
  "tooltipArrow--left": "CustomTooltip-module-scss-module__-Bf8oq__tooltipArrow--left",
  "tooltipArrow--right": "CustomTooltip-module-scss-module__-Bf8oq__tooltipArrow--right",
  "tooltipArrow--top": "CustomTooltip-module-scss-module__-Bf8oq__tooltipArrow--top",
  "tooltipContent": "CustomTooltip-module-scss-module__-Bf8oq__tooltipContent",
  "tooltipIn": "CustomTooltip-module-scss-module__-Bf8oq__tooltipIn",
});
